<template>
  <slot v-if="status === 'success'" />
  <div v-else-if="status === 'pending' || status === 'idle'">
    <slot name="loading" />
  </div>
  <slot v-else-if="status === 'error'" name="error">
    <slot name="loading" />
  </slot>
</template>

<script setup lang="ts">
import type { AsyncDataRequestStatus } from '#app'

const { status } = defineProps<{ status: AsyncDataRequestStatus }>()
</script>
